import React, { useMemo } from "react";
import AdminTable from "./AdminTable";
import { useHistory } from "react-router-dom";
import { Typography } from "@material-ui/core";
import { useClientsState } from "../../../context/clients";
import { UserState } from "../../../context/auth";
import {
  deleteIrrigator,
  Irrigator,
  IrrigatorType,
} from "../../../api/irrigators";
import { Client } from "../../../api/clients";

export default function IrrigatorsTable({
  user,
  activeClient,
  data,
  types,
  onRefresh,
}: {
  user: UserState;
  activeClient: Client | undefined;
  data: Irrigator[] | undefined;
  types: IrrigatorType[] | undefined;
  onRefresh: () => void;
}) {
  const history = useHistory();

  const clients = useClientsState();
  const clientMap = useMemo(
    () => new Map(clients.map((c) => [c.id, c.name])),
    [clients]
  );

  const irrigatorsWithClients = useMemo(() => {
    if (!data || !types) return [];
    const irrigatorsWithTypes = data.map((irrigator) => {
      const type = types.find((t) => t.id === irrigator.irrigator_type_id);
      if (type === undefined) return irrigator;
      return { ...irrigator, type: type.name };
    });

    if (activeClient) {
      return irrigatorsWithTypes
        .filter((irrigator) => irrigator.client_id === activeClient.id)
        .map((irrigator) => ({ ...irrigator, client: activeClient.name }));
    }
    return irrigatorsWithTypes.map((irrigator) => ({
      ...irrigator,
      client: clientMap.get(irrigator.client_id),
    }));
  }, [data, types, clientMap, activeClient]);

  const config = useMemo(
    () => ({
      columns: [
        {
          title: "Name",
          field: "name",
        },
        {
          title: "Phone number",
          field: "phone_number",
        },
        {
          title: "Client",
          field: "client",
        },
        {
          title: "Type",
          field: "type",
        },
      ],
      data: irrigatorsWithClients,
      options: { pageSizeOptions: [5, 10, 20, 50] },
    }),
    [irrigatorsWithClients]
  );

  // const history = useHistory();
  const onCreate = () => history.push("/admin/irrigator");
  const onEdit = (id: number) => history.push(`/admin/irrigator/${id}`);
  const onDelete = async (record: Irrigator) => {
    if (!user.token) return;
    return (await deleteIrrigator(user.token, record.id)).data;
  };

  return (
    <AdminTable
      title={<Typography variant="h2">Irrigators</Typography>}
      type="irrigator"
      config={config}
      onCreate={onCreate}
      onEdit={onEdit}
      onDelete={onDelete}
      onRefresh={onRefresh}
      deleteLabel="name"
    />
  );
}
